import React from 'react';

import { hasNFCSupport, isProductionEnvironment } from '../../utils/utils';
import { HideInProduction } from '../HideInProduction/HideInProduction';
import { NFCDevEnvInfo } from '../NFCDevEnvInfo/NFCDevEnvInfo';
import { NFCDetect } from './NFCDetect';
import { NFCNoSupport } from './NFCNoSupport';

interface NFCProps {
    translations: Record<string, string>;
}

export const NFC: React.FC<NFCProps> = ({ translations }) => {
    if (!isProductionEnvironment() && !hasNFCSupport()) {
        return (
            <>
                <NFCNoSupport translations={translations} />
                <HideInProduction>
                    <NFCDevEnvInfo />
                </HideInProduction>
                <NFCDetect translations={translations} />
            </>
        );
    }

    if (!hasNFCSupport()) {
        return <NFCNoSupport translations={translations} />;
    }

    return <NFCDetect translations={translations} />;
};
